import { Component, OnInit, inject } from '@angular/core';
import { BrandService } from './core/services/brand.service';
import { MixpanelService } from './core/services/mixpanel.service';
import { AuthService } from './core/services/auth.service';
import { environment } from 'environments/environment';
import { MixpanelEvent } from './core/constants/mixpanel-events.const';
import { FirebaseMessagingService } from './core/services/firebase-messaging.service';
import { NotificacaoService } from './core/services/notificacao.service';
import { PageViewTrackingService } from './core/services/analytics/page-view-tracking.service';

interface HotjarFunction {
  (...args: unknown[]): void;
  q: unknown[][];
}

interface WindowWithHotjar extends Window {
  hj?: HotjarFunction;
}

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
})
export class AppComponent implements OnInit {
  private readonly brandService = inject(BrandService);
  private readonly mixpanelService = inject(MixpanelService);
  private readonly authService = inject(AuthService);
  private readonly firebaseService = inject(FirebaseMessagingService);
  private readonly notificacaoService = inject(NotificacaoService);

  constructor() {
    inject(PageViewTrackingService);
  }

  ngOnInit() {
    this.brandService.initializeBrand();
    this.initializeMixpanel();
    this.initializeHotjar();
    this.setupAuthListener();
  }

  private initializeMixpanel(): void {
    this.mixpanelService.track(MixpanelEvent.APP_INICIALIZADO, {
      ambiente: environment.production ? 'producao' : 'desenvolvimento',
    });

    this.mixpanelService.setSuperProperties({
      app_version: '1.17.3',
      platform: 'web',
      environment: environment.production ? 'production' : 'development',
    });
  }

  private setupAuthListener(): void {
    this.authService.currentUser$.subscribe(user => {
      if (user) {
        this.initializeNotifications();
      }
    });
  }

  private initializeHotjar(): void {
    if (!environment.production) return;

    const w = window as WindowWithHotjar;

    if (w.hj) return;

    const hjFunction = ((...args: unknown[]) => {
      hjFunction.q = hjFunction.q || [];
      hjFunction.q.push(args);
    }) as HotjarFunction;

    hjFunction.q = [];
    w.hj = hjFunction;

    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://t.contentsquare.net/uxa/d5a3aee60d2e8.js';

    document.head?.appendChild(script);
  }

  private initializeNotifications(): void {
    this.notificacaoService.listar().subscribe({
      error: err => {
        console.error('[App] Erro ao carregar notificações:', err);
      },
    });

    this.firebaseService.initializeForAuthenticatedUser().catch(err => {
      console.error('[App] Erro ao configurar notificações:', err);
    });
  }
}
